import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
import { useCart } from '../context/CartContext';

export function FloatingCart() {
  const { itemCount, setIsOpen, getTotal } = useCart();

  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: price % 1 === 0 ? 0 : 2,
    }).format(price);
  };

  return (
    <AnimatePresence>
      {itemCount > 0 && (
        <motion.button
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0, opacity: 0 }}
          onClick={() => setIsOpen(true)}
          className="fixed bottom-4 right-4 md:bottom-8 md:right-8 z-40 flex items-center gap-2 md:gap-3 px-4 md:px-6 py-3 md:py-4 bg-gold text-background shadow-2xl hover:bg-gold-light transition-colors rounded-full md:rounded-none"
          data-testid="floating-cart-btn"
        >
          <div className="relative">
            <ShoppingBag className="w-5 h-5" />
            <span className="absolute -top-2 -right-2 w-5 h-5 bg-background text-gold text-xs rounded-full flex items-center justify-center font-medium">
              {itemCount}
            </span>
          </div>
          <div className="text-left">
            <p className="text-xs opacity-80 hidden md:block">Your Estimate</p>
            <p className="font-medium text-sm md:text-base">{formatPrice(getTotal())}</p>
          </div>
        </motion.button>
      )}
    </AnimatePresence>
  );
}
